<form>
  <ng-template #children></ng-template>
</form>
